import { render, staticRenderFns } from "./VehicleData.vue?vue&type=template&id=abace098"
import script from "./VehicleData.vue?vue&type=script&lang=ts"
export * from "./VehicleData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports